import { render, staticRenderFns } from "./NoneTransferAccountHint.vue?vue&type=template&id=48560597&"
import script from "./NoneTransferAccountHint.vue?vue&type=script&lang=js&"
export * from "./NoneTransferAccountHint.vue?vue&type=script&lang=js&"
import style0 from "./NoneTransferAccountHint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports